const homePage: Record<string, Record<string, string> | string> = {
    headerLinks: {
        requests: 'Мои заявки',
        requestsNew: 'Реестр заявок',
        campaigns: 'Главная страница',
    },
};

export default homePage;
